import type {Result, UseCase} from 'framework';
import type {NutritionPlanId} from '../../domain/nutrition-plan-id.value-object';
import type {NutritionPlanError} from '../../domain/errors';
import type {NutritionPlanRepository} from '../ports/nutrition-plan.repository';

export type DeleteNutritionPlanInput = {
  readonly planId: NutritionPlanId;
};

export class DeleteNutritionPlan implements UseCase<[DeleteNutritionPlanInput], void> {
  constructor(private readonly repository: NutritionPlanRepository) {}

  execute(input: DeleteNutritionPlanInput): Promise<Result<void, NutritionPlanError>> {
    return this.repository.delete(input.planId);
  }
}
